import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import Title from "../../Components/Layout/Title";

// Material UI
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

const slideImages = [
  "https://images.pexels.com/photos/6147175/pexels-photo-6147175.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500https://images.pexels.com/photos/6147175/pexels-photo-6147175.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  "https://images.pexels.com/photos/5053767/pexels-photo-5053767.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
];

const properties = {
  duration: 5000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true,
};

const useStyles = makeStyles({
  root: {
    minWidth: 250,
    marginBottom: "0.8rem",
  },
  header: {
    width: "100%",
  },
  title: {
    fontSize: 14,
    lineHeight: "18px",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
});

function Intro() {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title={<Title label=" Welcome to Studybud🎉🎉🎉" />}
      />
      <Slide {...properties}>
        <div className="each-slide">
          <div
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${slideImages[0]})`,
            }}
          >
            <Typography variant="h5" style={{ color: "#fff" }}>
              Stay connected with students online.
            </Typography>
          </div>
        </div>
        <div className="each-slide">
          <div
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${slideImages[1]})`,
            }}
          >
            <Typography variant="h5" style={{ color: "#fff" }}>
              Share ideas,knowledge &amp; experience.
            </Typography>
          </div>
        </div>
        <div className="each-slide">
          <div
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${slideImages[2]})`,
            }}
          >
            <Typography variant="h5" style={{ color: "#fff" }}>
              Stay up to date on your Feed.
            </Typography>
          </div>
        </div>
      </Slide>
      {/* <CardMedia
        className={classes.media}
        image="/static/images/cards/paella.jpg"
        title="Paella dish"
      />
      {/* <CardContent className={classes.title} component="div">
        <Typography
          variant="body1"
          alignItems="center"
          style={{
            color: "#0f1419",
            lineHeight: "20px",
            fontWeight: "400",
            alignItems: "center",
          }}
          display="block"
          gutterBottom
        >
          Welcome to Studybud
        </Typography>
      </CardContent> */}
    </Card>
  );
}

export default Intro;
